import React, { useState, useEffect } from "react";
import '../App.css'

function Home() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  const messages = [
    "Empower Your Business, Embrace new frontiers to reach your targets fast, secure and beyond boundaries",
    "Presenting the most reliable & seamless payments ecosystem for managing your online payments",
    "Comprehensive Solutions for connected banking encompassing UPI, TPAP & other intent-based payments"
  ];
  const [visibleIndex, setVisibleIndex] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisibleIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 5000);

    return () => clearTimeout(timer);
  }, [visibleIndex]);
  return (
    <div>
      <>
        <div className="first_nav_hero_about">
          {/* ======== 1.1. header section ======== */}
          <header>
            <nav className="container navbar navbar-expand-lg ">
              <div className="container-fluid">
                {/* site logo */}
                <a className="nav-logo p-0" href="/">
                  <img src="/assets/images/new_logo.svg" alt="logo" />
                </a>
                {/* navigation button  */}
                <button
                  className="navbar-toggle"
                  onClick={toggleNavbar}
                  type="button"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  data-cf-modified-2a89ad8e51888e2ea151ec41-=""
                >
                  <i className="fa-solid fa-bars" />
                </button>
                {/* navigation bar manu  */}
                <div
                  className={`mobileNav collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarSupportedContent"
                >
                  <ul className="navbar-nav d-flex justify-content-center align-items-center gap-lg-2 gap-md-2 gap-sm-2 gap-2 mb-2 mb-lg-0">
                    <li className="nav-item">
                      <a className="nav-link active" href="/">
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="/aboutus">
                        About us
                      </a>
                    </li>
                    {/*
                    <li className="nav-item">
                      <a className="nav-link" href="/feature">
                        Solutions
                      </a>
                    </li>*/}
                    <li className="nav-item">
                      <a className="nav-link" href="/Contactus">
                        Contact Us
                      </a>
                    </li>

                    {/* <li className="nav-item">
                      <a className="nav-link" href="/FAQ">
                        FAQ's
                      </a>
                    </li>*/}
                    {/* <li className="dropdown">
                <a className="nav-link " href="#">
                  Pages <i className="fa-sharp fa-solid fa-sort-down" />
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <a className="dropdown-item" href="pricing.html">
                      Pricing
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="contact.html">
                      Contact
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="team.html">
                      Team
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="testimonials.html">
                      Testimonials
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="blogs.html">
                      Blogs
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="faq.html">
                      FAQ
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="404.html">
                      404
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="coming.html">
                      Coming Soon
                    </a>
                  </li>
                </ul>
              </li> */}
                    {/* <li className="nav-item">
                <a id="search-bar-bt" className="nav-link" href="#">
                  <i className="fa-solid fa-magnifying-glass" />
                </a>
              </li> 

                    <a className=" btn-hover4" href="#">
                      Create Account
                    </a>*/}

                    {/* <li
                className="nav-item"
                onclick="if (!window.__cfRLUnblockHandlers) return false; open_right_side()"
                data-cf-modified-2a89ad8e51888e2ea151ec41-=""
              >
                <a className="nav-link" href="#">
                  <i className="fa-sharp fa-solid fa-bars" />
                </a>
              </li> */}
                  </ul>
                </div>
              </div>
            </nav>
            {/*============ navigation left slidebar================*/}
            <aside>
              <div id="mySidenav" className="sidenav">
                <div className="side-nav-logo d-flex justify-content-between align-items-center ps-4 pe-3">
                  <figure className="navbar-brand">
                    <a href="/">
                      <img
                        src="/assets/images/new_logo.svg"
                        alt="img"
                        className="nav-logo"
                      />
                    </a>
                  </figure>
                  <div
                    className="closebtn"
                    onclick="if (!window.__cfRLUnblockHandlers) return false; closeNav()"
                    data-cf-modified-2a89ad8e51888e2ea151ec41-=""
                  >
                    <i className="fa-solid fa-square-xmark side-bar-close-btn" />
                  </div>
                </div>
                <ul>
                  <li className="nav-item">
                    <a className="nav-link" aria-current="page" href="/">
                      Home
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="about.html">
                      About
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/feature">
                      Solutions
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="pricing.html">
                      Pricing
                    </a>
                  </li>
                  <li className="nav-item">
                    <div
                      className="d-flex align-items-center justify-content-between pt-3"
                      id="slid-btn"
                    >
                      <button className="a-slid">Pages</button>
                      <i className="fa-solid fa-caret-down pe-4" />
                    </div>
                    <ul id="slid-drop" className="myst">
                      <li>
                        <a href="contact.html">Contact</a>
                      </li>
                      <li>
                        <a href="team.html">Team</a>
                      </li>
                      <li>
                        <a href="testimonials.html">Testimonials</a>
                      </li>
                      <li>
                        <a href="blogs.html">Blogs</a>
                      </li>
                      <li>
                        <a href="faq.html">FAQ</a>
                      </li>
                      <li>
                        <a href="404.html">404</a>
                      </li>
                      <li>
                        <a href="coming.html">Coming Soon</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </aside>
            {/*================== navigation drop search bar================*/}
            <div className="search" id="search-bar">
              <form className="d-flex nav-search">
                <input type="text" name="search" placeholder="Enter your text" />
                <button className="btn-hover1" type="submit">
                  Search
                </button>
              </form>
              <button id="remove-btn">
                <i className="fa-solid fa-square-xmark " />
              </button>
            </div>
            {/*=================navigation Right slidebar==================*/}
            <section className="right-sidbar" id="right_side">
              <div className="d-flex justify-content-between align-items-center">
                {/* site logo */}
                <a className="p-0 " href="/">
                  <img src="/assets/images/new_logo.svg" alt="logo" />
                </a>
                <button
                  className="close_right_sidebar fa-solid fa-xmark"
                  onclick="if (!window.__cfRLUnblockHandlers) return false; close_right_sade()"
                  data-cf-modified-2a89ad8e51888e2ea151ec41-=""
                >
                  {" "}
                </button>
              </div>
              <p className="mt-4 pb-3">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
              <a href="#" className="btn-hover1">
                Discover More
              </a>
              <hr />
              <h5 className="mt-4 mb-4">Connected details:</h5>
              <ul className="d-flex flex-column gap-3">
                <li>
                  <a href="#">
                    {" "}
                    <i className="fa-solid fa-phone" />
                  </a>
                  <a href="#">
                    <span
                      className="__cf_email__"
                      data-cfemail="71081e04031f101c1431141c10181d5f121e1c"
                    >
                      [email&nbsp;protected]
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa-solid fa-envelope" />
                  </a>
                  <a href="#">+123-456-7890</a>
                </li>
                <li>
                  <a href="#">
                    <i className="fa-solid fa-clock" />
                  </a>
                  <a href="#">
                    Office Hours: 8AM - 11PM Sunday - Weekend Day
                  </a>
                </li>
              </ul>
              <span className="d-flex gap-4 mt-4">
                <a href="#" className="p-0">
                  <i className="fa-brands fa-facebook" />
                </a>
                <a href="#" className="p-0">
                  <i className="fa-brands fa-instagram" />
                </a>
                <a href="#" className="p-0">
                  <i className="fa-brands fa-twitter" />
                </a>
              </span>
            </section>
          </header>
          {/* ======== End of 1.1. header section ========  */}
          {/* ======== 1.2. hero section ======== */}
          <section className="hero">
            <div className="container">
              <div className="row text-md-start text-sm-center text-center gap-md-0 gap-sm-4 gap-5">
                <div
                  data-aos="fade-up"
                  className="col-md-6 d-flex align-items-md-start align-items-ms-center align-items-center justify-content-center flex-column"
                >
                  {messages.map((text, index) => (
                    <h3 key={index} style={{ display: index === visibleIndex ? "block" : "none" }}>
                      {text}
                    </h3>
                  ))}



                </div>
                <div
                  data-aos="fade-down"
                  className="col-md-6 position-relative d-flex flex-column justify-content-center align-items-center mt-md-0 mt-sm-5 mt-4"
                >
                  <img
                    src="/assets/New/hero.png"
                    alt="hero_img1"
                    className="moving"
                  />

                </div>
              </div>
            </div>
          </section>
          {/* ======== End of 1.2. hero section ========  */}
          {/* ======== 1.3. about section ========  */}
          <section className="about">
            <div className="container">
              <div className="row text-md-start text-sm-center text-center">
                <div className="col-md-6 d-flex justify-content-between">
                  <div className="ab_card1" data-aos="flip-left">
                    <h3>About</h3>
                    <p className="p-f-s">
                      At FinkeyPay, we simplify payment management with innovative, secure solutions for businesses. Whether online or in-store, our platform ensures seamless, efficient transactions, helping you save time, reduce costs, and enhance customer experience.
                    </p>
                    <div className="d-flex align-items-center justify-content-lg-start justify-content-md-center justify-content-center">
                      <a className="btn-hover3" href="/aboutus">
                        Learn More
                      </a>


                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex justify-content-center mt-md-0 mt-sm-3 mt-3">
                  <div
                    className="ab_card2 d-flex flex-column justify-content-between"
                    data-aos="flip-right"
                  >
                    <div>
                      <div className="row gap-md-0 gap-sm-3 gap-3">
                        <h4>Simplify Your Business With Finkeypay</h4>
                        <li className="p-f-s mt-3">
                          Connect your bank accounts to Finkeypay to easily send & receive payments
                        </li>
                        <li className="p-f-s mt-3">
                          Upload & pay bills on the go
                        </li>
                        <li className="p-f-s mt-3">
                          Review & track payable in our Finkeypay dashboard
                        </li>
                        <li className="p-f-s mt-3">
                          Support for net banking, UPI, credit or debit cards
                        </li>
                        <li className="p-f-s mt-3">
                          90% reduction in manual payments tasks through automation in our platform
                        </li>

                        <li className="p-f-s mt-3">
                          Track all your bank accounts in a single platform
                        </li>
                        <li className="p-f-s mt-3">
                          Perfect solution for all industries & sectors
                        </li>


                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        {/* ======== End of 1.3. about section ========  */}
        {/* ======== 1.4. finance section ========  */}
        <section className="finance">
          <div className="container text-center">
            <h3>Unlocking the power of faster & secure digital payments for all players across the spectrum:</h3>
            <p className="mt-0">
              Come Aboard Now!
            </p>
            <div className="finanes-card row gap-md-0 gap-sm-4 gap-4" style={{ justifyContent: 'center' }}>
              <div className="col-lg-4 col-md-4 d-flex justify-content-center pe-lg-3 pe-md-0 pe-sm-3 pe-3">
                <div className="fin-card" data-aos="flip-up">

                  <img src="/assets/New/Figure.svg" alt="praph" />
                  <h4>Sign Up</h4>
                  {/*
                  <p className="p-f-s">
                    Security and compliance are vital in BFSI. FinkeyPay offers a robust, PCI DSS-compliant gateway for secure transactions.
                  </p>*/}
                </div>
              </div>
              <div className="col-lg-4 col-md-4 d-flex justify-content-center pe-lg-3 pe-md-0 pe-sm-3 pe-3">
                <div className="fin-card" data-aos="flip-up">

                  <img src="/assets/New/Figure (1).svg" alt="doller" />
                  <h4>Connect your bank Account</h4>
                  {/*<p className="p-f-s">
                    Boost your online business with Haoda Pay’s reliable payment gateway. Accept payments through credit cards, UPI, wallets, and more
                  </p>*/}
                </div>
              </div>
              <div className="col-lg-4 col-md-4 d-flex justify-content-center">
                <div className="fin-card" data-aos="flip-up">

                  <img src="/assets/New/Figure (2).svg" alt="arow" />
                  <h4> Pay & Receive Payments in a single click</h4>
                  {/* <p className="p-f-s">
                    Streamline recurring billing and subscriptions with Haoda Pay’s tailored solutions for SaaS businesses
                  </p>*/}
                </div>
              </div>
              <div className="col-lg-4 col-md-4 d-flex justify-content-center pe-lg-3 pe-md-0 pe-sm-3 pe-3 mt-md-3 mt-lg-4">
                <div className="fin-card" data-aos="flip-up">

                  <img src="/assets/New/Figure (1).svg" alt="doller" />
                  <h4>Track your business in our Dashboard</h4>
                  {/*<p className="p-f-s">
                    Boost your online business with Haoda Pay’s reliable payment gateway. Accept payments through credit cards, UPI, wallets, and more
                  </p>*/}
                </div>
              </div>

            </div>
          </div>
        </section>
        {/* ======== End of 1.4. finance section ========  */}
        {/* ======== 1.5. ispsum section ========  */}
        <h3 className="text-center">Trusted By</h3>
        <div className="ispsum-logo">
          <div className="container">
            <hr />
            <div className="logo_ispsum_slider">
              <a href="#">
                <figure>
                  <img src="/assets/marquee/1.Clarion.png" alt="img" />
                </figure>
              </a>
              <a href="#" className="d-flex items-center">
                <figure>
                  <img src="/assets/marquee/2.destiny.png" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/3.National.jpeg" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/4.Universal.png" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/5.Ironhill.png" alt="img" />
                </figure>
              </a>
              <a href="#" className="d-flex items-center">
                <figure>
                  <img src="/assets/marquee/6.Afro-asian.png" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/7.Navabhoomi.png" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/8.Royal.jpeg" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/9.destiny-world-logo03.png" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/10.Greeco.jpeg" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/11.TSG.jpg" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/12.Universal_Foods.jpeg" alt="img" />
                </figure>
              </a>
              <a href="#">
                <figure>
                  <img src="/assets/marquee/13.Zythum.jpg" alt="img" />
                </figure>
              </a>
            </div>
            <hr />
          </div>
        </div>
        {/* ======== End of 1.5. ispsum section ========  */}
        {/* ======== 1.6. gateway section ========  */}
        <section className="gateway">
          <div className="container">
            <div className="row gap-lg-0 gap-md-0 gap-sm-4 gap-4">
              <div
                className="col-lg-6 col-md-6 d-flex align-items-center justify-content-center"
                data-aos="fade-up"
              >
                <div className="  mt-5 ">

                  <img
                    src="/assets/New/Hands.svg"
                    alt="gate_img1"
                    className="moving image-fluid w-100"
                  />

                </div>
              </div>
              <div
                className="col-lg-6 col-md-6  text-md-start text-sm-center text-center"
                data-aos="fade-down"
              >
                <h2>SIMPLIFY YOUR PAYMENT PROCESSES</h2>
                <p className="pt-lg-4 pt-md-3 pt-sm-2 pt-2 pb-2">
                  Simplifying your payment processes can be effortless with the right tools in place. Follow these three simple steps to streamline transactions and improve user experience with our payment gateway:
                </p>
                <div className="gate mt-md-3 mt-sm-0 mt-4   d-flex flex-md-row flex-sm-column flex-column align-items-center">
                  <figure className="d-flex align-items-center">
                    <img src="/assets/images/icon/gate-icon1.png" alt="gate-img1" />
                  </figure>
                  <div className="ms-lg-3 ms-md-3 ms-sm-0 ms-0">
                    <h5 className="pb-2">Start-ups</h5>

                  </div>
                </div>
                <div className="gate d-flex mt-4  flex-md-row flex-sm-column flex-column align-items-center">
                  <figure className="d-flex align-items-center">
                    <img src="/assets/images/icon/gate-icon2.png" alt="gate-img2" />
                  </figure>
                  <div className="ms-lg-3 ms-md-3 ms-sm-0 ms-0">
                    <h5 className="pb-2">Self Employed Professionals</h5>

                  </div>
                </div>
                <div className="gate d-flex mt-4  flex-md-row flex-sm-column flex-column align-items-center">
                  <figure className="d-flex align-items-center">
                    <img src="/assets/images/icon/gate-icon3.png" alt="gate-img3" />
                  </figure>
                  <div className="ms-lg-3 ms-md-3 ms-sm-0 ms-0">
                    <h5 className="pb-2">Small Businesses/ SMEs</h5>

                  </div>

                </div>
                <div className="gate mt-md-3 mt-sm-0 mt-4   d-flex flex-md-row flex-sm-column flex-column align-items-center">
                  <figure className="d-flex align-items-center">
                    <img src="/assets/images/icon/gate-icon1.png" alt="gate-img1" />
                  </figure>
                  <div className="ms-lg-3 ms-md-3 ms-sm-0 ms-0">
                    <h5 className="pb-2">Mid to Large Business Enterprises</h5>

                  </div>
                </div>
                <div className="gate d-flex mt-4  flex-md-row flex-sm-column flex-column align-items-center">
                  <figure className="d-flex align-items-center">
                    <img src="/assets/images/icon/gate-icon2.png" alt="gate-img2" />
                  </figure>
                  <div className="ms-lg-3 ms-md-3 ms-sm-0 ms-0">
                    <h5 className="pb-2">E-commerce & M-Commerce channels</h5>

                  </div>
                </div>
                <div className="gate-link text-lg-start text-md-start text-sm-center text-center">
                  <a className="btn-hover1" href="/aboutus">
                    Get Started
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ======== End of 1.6. gateway section ========  */}
        {/* ======== 1.7. services section ========  */}
        <section className="services">
          <div className="container">
            <div className="row gap-md-0 gap-sm-4 gap-4">
              <div className="col-lg-6 col-md-6" data-aos="fade-down">
                <h2 className="text-lg-start text-md-start text-sm-center text-center">
                  EXCEPTIONAL SERVICES AND SOLUTIONS
                </h2>
                <p className="text-lg-start text-md-start text-sm-center text-center mt-lg-4 mt-md-2 mt-sm-2 mt-2 pb-4 ">
                  Embark on a transformative journey with the FinkeyPay- your powerhouse for payment processing. Experience seamless transactions, unparalleled security, and custom solutions tailored for your business.
                </p>
                <div className="serives-btn justify-content-md-start justify-content-ms-center justify-content-center d-flex">

                  {/*<a className="btn-hover1" href="#">
                    Learn More
                  </a>*/}
                  <div className="d-flex align-items-center">
                    <a className="ps-4" href="https://finkey-dash.paytring.com/login">
                      Register Now{" "}
                    </a>
                    <i className="fa-solid fa-greater-than ps-md-3 ps-sm-1 ps-0" />
                  </div>
                </div>
              </div>
              <div
                className="col-lg-6 col-md-6 d-flex align-items-center justify-content-center Freplacing"
                data-aos="fade-up"
              >
                <div className="position-relative">
                  <div className=" d-flex  justify-content-center gap-lg-4 gap-md-3 gap-sm-2 gap-2">
                    <div className="offers">
                      <h5 className="mb-2">Global Reach</h5>
                      <p className="p-f-s">
                        Expand your business globally with our payment gateway's multi-currency support, to accept payments from customers worldwide.
                      </p>
                    </div>
                    <div className="offers">
                      <h5 className=" mb-2">Reliable Customer Support</h5>
                      <p className="p-f-s">
                        We provide dedicated customer support to assist you with any queries or technical issues
                      </p>
                    </div>
                  </div>
                  {/*
                  <figure>
                    <img
                      src="/assets/New/Exceptional.png"
                      alt="sevice_img2"
                      className="image-fluid w-100"
                    />
                  </figure>
                  <figure>
                    <img src="/assets/images/icon/whitStar.png" alt="sevice_img3" />
                  </figure>
                  */}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ======== End of 1.7. services section ========  */}
        {/* ======== 1.8. visa section ========  */}
        <section className="visa">
          <div className="container">
            <div className="visa-bg" data-aos="zoom-in">
              <figure>
                <img src="/assets/New/Replacing.svg" alt="visa-img" />
              </figure>
            </div>
            <div className="visa-contant" data-aos="fade-up">
              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <h3 className="text-md-start text-sm-center text-center">
                    Replacing complexity with simplicity
                  </h3>
                  <p className="text-md-start text-sm-center text-center p-f-s">
                    <ul style={{ listStyleType: 'disc', paddingLeft: '10px' }}>
                      <li>Better Conversions than ever</li>
                      <li>Flaunt your Brand with Custom UI</li>
                      <li>Easy Integration with less code</li>
                      <li>Personalised payment experience for every user</li>
                    </ul>
                  </p>
                  <div className="visa-btn text-sm-center text-md-start text-center">
                    <a className="btn-hover1" href="https://finkey-dash.paytring.com/login">
                      Sign up now
                    </a>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="visa-logo pt-2 pb-3">
                    <figure>
                      <img src="/assets/images/icon/vis-1.png" alt="vica-icon1" />{" "}
                    </figure>
                    <figure>
                      <img src="/assets/images/icon/ves-2.png" alt="vica-icon2" />
                    </figure>
                    <figure>
                      <img src="/assets/images/icon/ves-3.png" alt="vica-icon3" />
                    </figure>
                    <figure>
                      <img src="/assets/images/icon/ves-4.png" alt="vica-icon4" />
                    </figure>
                    <figure>
                      <img src="/assets/images/icon/ves-5.png" alt="vica-icon5" />
                    </figure>
                  </div>
                  <div className="d-flex pt-2 justify-content-md-start justify-content-center justify-content-center">
                    <h2 className="count">280</h2>
                    <h2>+</h2>
                    <h6 className="d-flex align-items-center ps-2 ">Integrations</h6>
                  </div>
                  <p className="pt-2 pb-3 text-md-start text-sm-center text-center p-f-s">
                    FinkeyPay makes moving money effortless and customizable. Serving a global client base, we help businesses of all sizes process transactions seamlessly and securely, so you can focus on what matters most — your business.
                  </p>
                  {/*
                  <div className="visa-card position-relative mt-3">
                    <img src="/assets/New/Group 6@2x.svg" alt="visa-card" />
                  </div>*/}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ======== End of 1.8. visa section ========  */}
        {/* ========  1.9. pricing section ========  */}
        <section className="pricing pricing-b-g">
          <div className="container">
            <div className="d-flex align-items-center">
              <div
                className="col-lg-6 col-md-6 d-flex align-items-center justify-content-center pricing-bg"
                data-aos="fade-up"
              >
                <div>
                  <figure>
                    <img
                      src="/assets/New/Economical.png"
                      alt="pric-img1"
                      className="moving"
                    />
                  </figure>

                </div>
              </div>
              <div
                className="col-lg-6 col-md-6 mt-md-0 mt-sm-5 mt-5"
                data-aos="fade-down"
              >
                <h2 className=" text-md-start text-sm-center text-center">
                  Our Guiding Values
                </h2>
                <p className="text-md-start text-sm-center text-center p-md-0 p-sm-2 p-2">
                  At FinkeyPay, our values shape every decision we make and every service we deliver. They are the foundation of how we operate and the compass that guides us toward building lasting partnerships. Here’s what drives us:
                </p>
                {/*
                <div className="pric-list">
                  <h6>Innovation & excellence</h6>
                  <div className="d-flex">
                    <div className="mt-3 me-3">
                      <i className="fa-solid fa-check" />
                    </div>
                    <div className="d-flex justify-content-between gap-1">
                      <p className="p-f-s">
                        We continuously innovate and set high standards, staying ahead of trends to deliver optimal solutions for our clients.
                      </p>
                      <div className="d-flex pric-sup">
                        <h2>$</h2>
                        <h2>1.54</h2>
                        <p>/month</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pric-list second">
                  <h6>Trust & Transparency</h6>
                  <div className="d-flex justify-content-between">
                    <div className="mt-3 me-3">
                      <i className="fa-solid fa-check" />
                    </div>
                    <div className="d-flex justify-content-between">
                      <p className="p-f-s">
                        We build trust through honesty, clear communication, and fair practices, fostering lasting relationships with clients and partners.
                      </p>
                      <div className="d-flex pric-sup ">
                        <h2>$</h2>
                        <h2>4.54</h2>
                        <p>/month</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-md-start text-sm-center text-center pt-lg-4 pt-md-2 pt-sm-0 pt-1">
                  <a className="btn-hover1" href="#">
                    Get Started
                  </a>
                </div>*/}
              </div>
            </div>
          </div>
        </section>
        {/* ======== End of 1.9. pricing section ========  */}
        {/* ======== 1.10. profaessional section ========  */}
        <section className="profaessional">
          <div className="container">
            <h2 className="text-center">Trusted By Professionals</h2>
            <div className="prof-size" data-aos="zoom-in-up">
              <div className="prof-slider ">
                <div className="prof-slide position-relative">
                  <div>
                    <div className="d-flex  align-items-center justify-content-center">
                      <img
                        src="/assets/images/slider/profational2.png"
                        alt="img"
                        className="prof-img-2"
                      />
                    </div>
                    <div>
                      <img
                        src="/assets/images/slider/Comma.png"
                        alt="img"
                        className="prof-img-1"
                      />
                    </div>
                    <p className="text-center p-f-s">
                      FinkeyPay’s approach to payments has given us the flexibility we need to scale. The platform is reliable and user friendly. We're excited about the potential it holds for our future growth.
                    </p>
                    <div className="prof-star pt-2 pb-2 text-center">
                      <span className="stars text-lg-start">
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                      </span>
                    </div>
                    <h5 className="text-center">Johnny Stone</h5>
                    <p className="text-center pt-2 pb-5 p-f-s">Enterpreneur</p>
                  </div>
                </div>
                <div className="prof-slide position-relative">
                  <div>
                    <div className="d-flex  align-items-center justify-content-center">
                      <img
                        src="/assets/images/slider/profactional3.png"
                        alt="img"
                        className="prof-img-2"
                      />
                    </div>
                    <div>
                      <img
                        src="/assets/images/slider/Comma.png"
                        alt="img"
                        className="prof-img-1"
                      />
                    </div>
                    <p className="text-center p-f-s">
                      Partnering with FinkeyPay was a great decision for us. They’ve shown impressive dedication to customer satisfaction and efficiency in payment processing.
                    </p>
                    <div className="prof-star pt-2 pb-2 text-center">
                      <span className="stars text-lg-start">
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                      </span>
                    </div>
                    <h5 className="text-center">Stephen Stewart</h5>
                    <p className="text-center pt-2 pb-5 p-f-s">Entrepreneur</p>
                  </div>
                </div>
                <div className="prof-slide position-relative">
                  <div>
                    <div className="d-flex  align-items-center justify-content-center">
                      <img
                        src="/assets/images/slider/profacitional.png"
                        alt="img"
                        className="prof-img-2"
                      />
                    </div>
                    <div>
                      <img
                        src="/assets/images/slider/Comma.png"
                        alt="img"
                        className="prof-img-1"
                      />
                    </div>
                    <p className="text-center p-f-s">
                      Their seamless integration and commitment to delivering high-quality service have made a significant impact on our operations. We're excited to continue working with such a forward-thinking partner.
                    </p>
                    <div className="prof-star pt-2 pb-2 text-center">
                      <span className="stars text-lg-start">
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                      </span>
                    </div>
                    <h5 className="text-center">Tom Hiddellon</h5>
                    <p className="text-center pt-2 pb-5 p-f-s">Entrepreneur</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ======== End of 1.10. profaessional section ========  */}
        {/* ======== 1.11. question section ========  
        <section className="question">
          <div className="container">
            <div className="row">
              <div
                className="question-text col-lg-6 col-md-6 tab-center "
                data-aos="fade-up"
              >
                <h2 className="text-lg-start text-md-start text-sm-center text-center">
                  FREQUENTLY ASKED QUESTIONS
                </h2>
                <p className="text-lg-start text-md-start text-sm-center text-center mt-md-3 me-lg-3 mt-3">
                  Get answers to common questions about FinkeyPay, including security, integration, and setup. Our platform ensures seamless transactions with top-tier security and easy compatibility for businesses of all sizes.
                </p>
                <div className="text-lg-start text-md-start text-sm-center text-center ">
                  <a className="btn-hover1" href="/FAQ">
                    More FAQs
                  </a>
                </div>
              </div>
              <div
                className="question-collapes col-lg-6 col-md-6 mt-md-0 mt-sm-3 mt-3 mb-5"
                data-aos="zoom-in"
              >
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h5 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        What is FinkeyPay?
                      </button>
                    </h5>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          FinkeyPay is a top-tier payment gateway solution that empowers businesses to accept online payments securely and effortlessly. Our platform offers easy integration and supports a wide range of payment methods, enabling businesses to grow their customer base and optimize their payment operations with ease.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h5 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        How does FinkeyPay ensure the security of online transactions?
                      </button>
                    </h5>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          At FinkeyPay, we prioritize the security of your transactions. We are PCI DSS Level 1 compliant, which is the highest level of security certification in the payment card industry. We implement advanced encryption protocols and fraud prevention measures to safeguard your business and customer data.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h5 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        Can I integrate FinkeyPay with my existing website or e-commerce platform?
                      </button>
                    </h5>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Absolutely! FinkeyPay is designed for easy integration with various platforms.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h5 className="accordion-header" id="headingFour">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        How long does it take to set up FinkeyPay for my business?
                      </button>
                    </h5>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <p>
                          The setup process for FinkeyPay is efficient and streamlined. Depending on your specific requirements, the setup can be completed within a few days.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>*/}
        {/* ======== End of 1.11. question section ========  */}
        {/* ======== 1.12. news-cards section ========  
        <section className="news-cards">
          <div className="container">
            <h2 className="text-center">OUR LATEST NEWS &amp; EVENTS</h2>
            <p className="text-center news-p">
              Stay updated with the latest insights, trends, and expert tips to grow your business successfully.
            </p>
            <div className="row d-flex gap-md-0 gap-sm-5 gap-4">
              <div className="col-lg-4 col-md-4 d-flex" data-aos="flip-right">
                <div className="card news-card-back">
                  <img src="/assets/New/Blog-1.svg" alt="card-img" />
                  <div className="card-body">
                    <a href="#">
                      <h5 className="choosing">Choosing a Payment Gateway: Key Factors to Consider</h5>
                    </a>
                    <p className="card-text p-f-s">
                      Multi Payment- Support for various payment methods including debit and credit cards.
                    </p>
                  </div>
                  <hr className="dotted-line" />
                  <div className="card-viewer d-flex justify-content-between ">
                    <div>
                      <i className="fa-solid fa-calendar-days" />
                      <span>2023/06/12</span>
                    </div>
                    <div>
                      <i className="fa-regular fa-message" />
                      <span>0</span>
                    </div>
                  </div>
                  <div className="news-link">
                    <a className="btn-hover1" href="#">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 d-flex" data-aos="flip-right">
                <div className="card news-card-back">
                  <img src="/assets/New/Blog-2.svg" alt="image" />
                  <div className="card-body">
                    <a href="#">
                      <h5 className="choosing">Top Strategies to do Successful Online Business</h5>
                    </a>
                    <p className="card-text p-f-s">
                      Robust Security- Ensure Transaction safety with advanced encryption and industry best practices
                    </p>
                  </div>
                  <hr className="dotted-line" />
                  <div className="card-viewer d-flex justify-content-between ">
                    <div>
                      <i className="fa-solid fa-calendar-days" />
                      <span>2023/06/12</span>
                    </div>
                    <div>
                      <i className="fa-regular fa-message" />
                      <span>0</span>
                    </div>
                  </div>
                  <div className="card-color">
                    <a className="btn-hover1" href="#">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 d-flex" data-aos="flip-right">
                <div className="card news-card-back">
                  <img src="/assets/New/Blog-3.svg" alt="image" />
                  <div className="card-body">
                    <a href="#">
                      <h5 className="choosing">The Benefits of Microfinancing for Small Business</h5>
                    </a>
                    <p className="card-text p-f-s">
                      Intelligent Routing- Optimise transactions by auto selecting the best payment processor
                    </p>
                  </div>
                  <hr className="dotted-line" />
                  <div className="card-viewer d-flex justify-content-between ">
                    <div>
                      <i className="fa-solid fa-calendar-days" />
                      <span>2023/06/12</span>
                    </div>
                    <div>
                      <i className="fa-regular fa-message" />
                      <span>0</span>
                    </div>
                  </div>
                  <div>
                    <a className="btn-hover1" href="#">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>*/}
        {/* ======== End of 1.12. news-cards section ========  */}
        {/* ======== 1.13. footer section ========  */}
        <footer className="position-relative">
          <div className="container">
            <h4 className="text-center">SUBSCRIBE OUR NEWSLETTER</h4>
            <p className="text-center pt-2 pb-3">Get latest News and Updates</p>
            <form
              className="d-flex align-items-center justify-content-center"
              id="footer-sub2"
            >
              {/* form Subscribe massage */}
              <div id="Succes-box2" />
              <div className="d-flex footer-search">
                <input
                  type="email"
                  name="search"
                  placeholder="Enter your Email"
                  required=""
                />
                <button type="submit" className="btn-hover1">
                  Subscribe
                </button>
              </div>
            </form>
            <div className="footer-logo text-center pb-lg-4 pb-md-3 pb-sm-2 pb-4">
              {/* footer logo  */}
              <a href="/">
                <figure>
                  <img src="/assets/images/new_logo.svg" alt="img" />
                </figure>
              </a>
            </div>
            <ul className="d-flex align-items-center justify-content-center">
              {/*<li>
                <a className="foot" href="/feature">Solutions</a>
              </li>*/}
              <li>
                <a className="foot" href="/Contactus">Contact Us</a>
              </li>
              <li>
                <a className="foot" href="/aboutus">About us</a>
              </li>
              {/*<li>
                <a className="foot" href="/FAQ">Faq</a>
              </li>*/}
            </ul>
            <hr />
            <div className="d-flex justify-content-center footer-nav-icon">
              {/* footer social icon  
              <div className="col-lg-3 col-md-3 d-flex align-items-center justify-content-md-start justify-content-sm-center justify-content-center">
                <div className="social-icon d-flex gap-2 justify-content-md-start justify-content-sm-center justify-content-center">
                  <a href="#">
                    {" "}
                    <i className="fa-brands fa-facebook-f foot-facebook" />
                  </a>
                  <a href="#">
                    {" "}
                    <i className="fa-brands fa-twitter" />
                  </a>
                  <a href="#">
                    {" "}
                    <i className="fa-brands fa-instagram" />
                  </a>
                </div>
              </div>
              */}
              {/* footer terms privacy  */}
              <div className="col-lg-6 col-md-6 d-flex justify-content-center align-items-center">
                <div className=" d-flex gap-3 p-2">
                  <a target="_blank" href="/assets/pdfs/Terms&Condition_Finkey.pdf" className="footer-terms">Terms &amp; Condition</a>
                  <a target="_blank" href="/assets/pdfs/Privacy_Policy_Finkey.pdf" className="footer-terms" >Privacy Policy</a>
                  <a target="_blank" href="/assets/pdfs/Refund_Policy_Finkey.pdf" className="footer-terms" >Refund Policy</a>
                </div>
              </div>
              {/* footer logo slider  */}
            </div>
            <hr />
            <div className="Copyright d-flex justify-content-between flex-wrap dir">
              <a className="footer-copyright">Copyright © 2024 FinkeyPay. All Right Reserved.</a>
              <a className="footer-copyright">FinkeyPay</a>
            </div>
          </div>
        </footer>
      </>


    </div>
  )
}

export default Home
